import { captureException } from '@paybis/frontend-common-lib/src/plugins/sentry';
import Vue from 'vue';

export default () => {
  if (process.env.NODE_ENV !== 'production') return;
  
  window.onunhandledrejection = (event) => {
    const { reason = {} } = event;

    if (reason instanceof Error) {
      captureException({ error: reason });
      return;
    }

    try {
      const formattedErrorName = typeof reason === 'string' ? reason : JSON.stringify(reason);
      const errorInstance = new Error(`Unhandled Rejection: ${formattedErrorName}`);

      captureException({ error: errorInstance });
    } catch (e) {
      // Exception while JSON parsing, if reason is not a json object
      captureException({ error: new Error('Unhandled Rejection'), extra: { reason } });
    }
  };

  Vue.config.errorHandler = (error, vm, info) => {
    captureException({ error, extra: { info } });
  };
};
